import * as t from 'io-ts';
import { DateFromISOString } from 'io-ts-types';
import { False, True } from '@thingos/io-ts-shared';
import { TagId } from './tag';
export const TemplateBase = t.type({
    name: t.string,
    vendor: t.string,
    version: t.string,
    reference: t.string,
    description: t.union([t.string, t.null]),
});
export const TemplateDraft = t.intersection([
    t.partial(TemplateBase.props),
    t.type({
        id: t.string,
    }),
    t.partial({
        connectFileId: t.string,
        connectFileName: t.string,
        connectFileSize: t.number,
        imageUrl: t.string,
    }),
]);
export const ValidTemplate = t.intersection([
    TemplateBase,
    t.type({
        id: t.string,
        connectFileId: t.string,
        connectFileName: t.string,
        connectFileSize: t.number,
        imageUrl: t.string,
    }),
]);
export const TemplateInfo = t.union([
    t.intersection([
        TemplateDraft,
        t.type({
            isDraft: True,
            updatedAt: DateFromISOString,
            tagIds: t.array(TagId),
        }),
    ]),
    t.intersection([
        ValidTemplate,
        t.type({
            isDraft: False,
            updatedAt: DateFromISOString,
            tagIds: t.array(TagId),
        }),
    ]),
]);
export const Template = t.intersection([
    TemplateBase,
    t.type({
        id: t.string,
        template: t.string,
        imageUrl: t.string,
    }),
]);
//# sourceMappingURL=template.js.map